import { FC, memo, useCallback, useMemo, useState } from 'react'
import Lightbox from 'react-image-lightbox'
import 'react-image-lightbox/style.css'
import { applyImagePolicy, ImageMode, ImageSizes } from '@/utils/imageExtension'
import useDevice from '../../hooks/useDevice'

type FullscreenGalleryProps = {
  images: string[]
  initialIndex: number
  onClose: () => void
}

const FullscreenGallery: FC<FullscreenGalleryProps> = memo(
  ({ images, initialIndex, onClose }) => {
    const [currentIndex, setCurrentIndex] = useState<number>(() => initialIndex)

    const onMovePrevRequest = useCallback(
      () => setCurrentIndex(Math.max(0, currentIndex - 1)),
      [currentIndex]
    )
    const onMoveNextRequest = useCallback(
      () => setCurrentIndex(currentIndex + 1),
      [currentIndex]
    )
    const nextSrc =
      currentIndex + 1 < images.length ? images[currentIndex + 1] : undefined

    const prevSrc = currentIndex - 1 > -1 ? images[currentIndex - 1] : undefined

    const { isMobile } = useDevice()

    const mainSrc = useMemo(
      () =>
        !isMobile
          ? applyImagePolicy(images[currentIndex], {
              mode: ImageMode.Local,
              size: ImageSizes['1400x1400']
            })
          : images[currentIndex],
      [currentIndex]
    )
    return (
      <Lightbox
        mainSrc={mainSrc}
        nextSrc={nextSrc}
        prevSrc={prevSrc}
        onCloseRequest={onClose}
        onMovePrevRequest={onMovePrevRequest}
        onMoveNextRequest={onMoveNextRequest}
        wrapperClassName="light-style-wrapper"
        data-testid="fullScreenGallery"
      />
    )
  }
)

export default FullscreenGallery
